import React, { useState, useEffect } from 'react'
import queryString from 'query-string'
import { differenceInDays } from 'date-fns'
import { format, formatInTimeZone } from 'date-fns-tz'
import htmlParser from 'html-react-parser'
import axios from 'axios'
import { useParams } from 'react-router-dom'

import Ticker from 'react-ticker'

import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';

import logo from "./../../assets/logo/logo.svg";
import poweredByStripe from "./../../assets/images/poweredByStripeBlack.svg"
import {
    useTheme
} from "native-base";
import {
    CircularProgress,
    Typography,
    Button,
    TextField,
    LinearProgress,
    InputAdornment,
    ToggleButtonGroup,
    ToggleButton
} from '@mui/material'
import FontPicker from "font-picker-react";
import { Font } from "@samuelmeuli/font-manager"

import { AuthAccount, FundraisingCampaign, FundraisingCampaignAmbassador, FundraisingCampaignAmbassadorContact, FundraisingCampaignType } from "../../API"

import awsconfig from './../../aws-exports'
import { Auth, Storage, API } from 'aws-amplify';
import AWSAppSyncClient, { AUTH_TYPE } from 'aws-appsync';
import gql from 'graphql-tag';

import { getAuthAccount, getFundraisingCampaign, getFundraisingCampaignAmbassador, getFundraisingCampaignAmbassadorContact, getFundraisingProfile } from '../../managers/graphql/queries';
import { Checkbox, FormControlLabel } from '@mui/material'
import ProfileAvatar from '../../components/data-display/ProfileAvatar'

ChartJS.register(ArcElement, Tooltip, Legend);

export default function Landing(props: any) {

    const { id }: any = useParams()

    const { colors } = useTheme()

    const [fundraisingCampaign, setFundraisingCampaign] = useState<FundraisingCampaign | null>(null)
    const [fundraisingOrganizationLogo, setFundraisingOrganizationLogo] = useState<string | null>(null)
    const [fundraisingOrganizationHeaderImage, setFundraisingOrganizationHeaderImage] = useState<string | null>(null)
    const [fundraisingCampaignAmbassadorContact, setFundraisingCampaignAmbassadorContact] = useState<FundraisingCampaignAmbassadorContact | null>(null)
    const [fundraisingCampaignAmbassador, setFundraisingCampaignAmbassador] = useState<FundraisingCampaignAmbassador | null>(null)
    const [fundraisingCampaignAmbassadorAuthAccount, setFundraisingCampaignAmbassadorAuthAccount] = useState<AuthAccount | null>(null)
    const [fundraisingCampaignAnalytics, setFundraisingCampaignAnalytics] = useState<any>(null)
    const [fundraisingCampaignDonors, setFundraisingCampaignDonors] = useState<any>(null)
    const [fundraisingCampaignInitialDonors, setFundraisingCampaignInitialDonors] = useState<any>(null)
    const [fundraisingCampaignAmbassadorAnalytics, setFundraisingCampaignAmbassadorAnalytics] = useState<any>(null)

    const [ambassadorProfilePicture, setAmbassadorProfilePicture] = useState<string | null>(null)

    const [givingCircleSelectedDonation, setGivingCircleSelectedDonation] = useState<string | null>(null)
    const [givingCircleCustomDonationAmount, setGivingCircleCustomDonationAmount] = useState<string | null>(null)

    const [manageSubscriptionEmail, setManageSubscrtiptionEmail] = useState<string | null>(null)

    const [headerSelectedFont, setHeaderSelectedFont] = useState<Font | undefined>(undefined)
    const [bodySelectedFont, setBodySelectedFont] = useState<Font | undefined>(undefined)

    const [doughnutData, setDoughnutData] = useState<any>(null)

    const [donationAmount, setDonationAmount] = useState<string | null>(null)
    const [anonymousDonation, setAnonymousDonation] = useState<boolean>(false)
    const [donorName, setDonorName] = useState<string | null>(null)

    const [pageStyle, setPageStyle] = useState<'overview' | 'ambassador' | 'initial-donation' | ''>('overview')

    const [donateAgain, setDonateAgain] = useState<boolean>(false)

    useEffect(() => {
        console.log(fundraisingCampaignInitialDonors)
    }, [fundraisingCampaignInitialDonors])

    useEffect(() => {
        (async () => {
            console.log(id)
            if (id) {

                const getFundraisingCampaignAmbassadorResponse: any = await API.graphql({
                    query: `
                    query GetFundraisingCampaignAmbassador($id: ID!) {
                      getFundraisingCampaignAmbassador(id: $id) {
                        id
                        status
                        fundraisingProfileID
                        fundraisingCampaignID
                        fundsRaised
                        initialTransactionID
                        initialTransactionAmount
                        ambassadorSpecificCtaUrl
                        createdAt
                        updatedAt
                        fundraisingProfile {
                          id
                          authAccountID
                          authAccount {
                            firstName
                            lastName
                          }
                          organizationID
                          email
                          firstName
                          lastName
                          createdAt
                          updatedAt
                          owner
                        }
                        fundraisingCampaign {
                          id
                          type
                          organizationID
                          staffLeadID
                          campaignName
                          introVideoURI
                          textMessageTemplate
                          phoneCallScriptTemplate
                          followUpMessageTemplate
                          followUpYesMessageTemplate
                          followUpNoMessageTemplate
                          showVideo
                          showText
                          showCall
                          showFollowUp
                          active
                          publicVideoID
                          publicVideoProvider
                          campaignEndDate
                          publicCampaignAbout
                          campaignGoal
                          perAmbassadorGoal
                          perContactDonationGoal
                          progressChartType
                          ctaURL
                          createdAt
                          updatedAt
                          owner
                        }
                        owner
                        fundraisingCampaignAmbassadorContacts {
                          nextToken
                        }
                      }
                    }
                  `,
                    variables: {
                        id: id
                    },
                    authMode: 'AWS_IAM'

                })

                console.log('ambassador data: ', getFundraisingCampaignAmbassadorResponse)

                if (getFundraisingCampaignAmbassadorResponse && getFundraisingCampaignAmbassadorResponse.data && getFundraisingCampaignAmbassadorResponse.data.getFundraisingCampaignAmbassador) {
                    setFundraisingCampaignAmbassador(getFundraisingCampaignAmbassadorResponse.data.getFundraisingCampaignAmbassador)
                }

                const { data }: any = await API.graphql({
                    query: `
                    query GetFundraisingCampaign($id: ID!) {
                      getFundraisingCampaign(id: $id) {
                        id
                        type
                        organizationID
                        staffLeadID
                        campaignName
                        introVideoURI
                        textMessageTemplate
                        phoneCallScriptTemplate
                        followUpMessageTemplate
                        followUpYesMessageTemplate
                        followUpNoMessageTemplate
                        showVideo
                        showText
                        showCall
                        showFollowUp
                        active
                        publicVideoID
                        publicVideoProvider
                        campaignEndDate
                        publicCampaignAbout
                        campaignGoal
                        perAmbassadorGoal
                        perContactDonationGoal
                        progressChartType
                        ctaURL
                        primaryColor
                        buttonBackgroundColor
                        buttonTextColor
                        secondaryColor
                        headerFont
                        bodyFont
                        givingCircleBaseAmount
                        givingCircleIncrements
                        givingCircleAllowCustomAmounts
                        createdAt
                        updatedAt
                        staffLead {
                          id
                          authAccountID
                          organizationID
                          role
                          name
                          createdAt
                          updatedAt
                          owner
                        }
                        organization {
                          id
                          name
                          shortName
                          description
                          locationID
                          website
                          phoneNumber
                          stripeConnectedAccountID
                          stripeConnectedAccountStatus
                          headerImageURI
                          ambassadorTermOverrideSingular
                          ambassadorTermOverridePlural
                          createdAt
                          updatedAt
                          ambassadorTermOverrideSingular
                          ambassadorTermOverridePlural
                          owner
                        }
                        owner
                      }
                    }
                  `,
                    variables: {
                        id: getFundraisingCampaignAmbassadorResponse.data.getFundraisingCampaignAmbassador.fundraisingCampaignID
                    },
                    authMode: 'AWS_IAM'

                })

                console.log(data)
                if (data && data.getFundraisingCampaign) {
                    setFundraisingCampaign(data.getFundraisingCampaign)

                    setDonationAmount(data.getFundraisingCampaign.perContactDonationGoal ? data.getFundraisingCampaign.perContactDonationGoal : 0)

                    if (data.getFundraisingCampaign && data.getFundraisingCampaign.organizationID) {
                        const headerURI = await Storage.get(`organizations/${data.getFundraisingCampaign.organizationID}/headerImage`, { level: 'public' })
                        if (headerURI) setFundraisingOrganizationHeaderImage(headerURI)
                        const profileURI = await Storage.get(`organizations/${data.getFundraisingCampaign.organizationID}/profilePicture`, { level: 'public' })
                        if (profileURI) setFundraisingOrganizationLogo(profileURI)
                    }

                    if (data.getFundraisingCampaign)

                        var campaignAnalytics = null;

                    if (queryString.parse(window.location.search).ambassador) {
                        campaignAnalytics = await axios.get(`https://9yim6q5pnf.execute-api.us-east-2.amazonaws.com/production/fundraising-campaign/analytics?fundraisingCampaignID=${data.getFundraisingCampaign.id}&fundraisingCampaignAmbassadorID=${queryString.parse(window.location.search).ambassador}`)
                    } else {
                        campaignAnalytics = await axios.get(`https://9yim6q5pnf.execute-api.us-east-2.amazonaws.com/production/fundraising-campaign/analytics?fundraisingCampaignID=${data.getFundraisingCampaign.id}`)
                    }

                    if (data.getFundraisingCampaign.headerFont) setHeaderSelectedFont(JSON.parse(data.getFundraisingCampaign.headerFont))
                    if (data.getFundraisingCampaign.bodyFont) setBodySelectedFont(JSON.parse(data.getFundraisingCampaign.bodyFont))

                    console.log(campaignAnalytics)
                    if (campaignAnalytics.data && campaignAnalytics.data.analytics) setFundraisingCampaignAnalytics(campaignAnalytics.data.analytics)
                    if (campaignAnalytics.data && campaignAnalytics.data.donations) setFundraisingCampaignDonors(campaignAnalytics.data.donations)
                    if (campaignAnalytics.data && campaignAnalytics.data.initialAmbassadorDonations) setFundraisingCampaignInitialDonors(campaignAnalytics.data.initialAmbassadorDonations)
                    if (campaignAnalytics.data && campaignAnalytics.data.ambassadors) setFundraisingCampaignAmbassadorAnalytics(campaignAnalytics.data.ambassadors)
                }
            }

            if (fundraisingCampaignAmbassadorContact == null && queryString.parse(window.location.search).contact) {

                console.log(queryString.parse(window.location.search))
                const { data }: any = await API.graphql({
                    query: `
                    query GetFundraisingCampaignAmbassadorContact($id: ID!) {
                      getFundraisingCampaignAmbassadorContact(id: $id) {
                        id
                        deviceContactID
                        fundraisingProfileID
                        fundraisingCampaignID
                        fundraisingCampaignAmbassadorID
                        sentText
                        sentPhoneCallScript
                        called
                        sentFollowUp
                        followUpResponse
                        isDonating
                        donationAmount
                        transactionID
                        isActive
                        notes
                        createdAt
                        updatedAt
                        fundraisingCampaignAmbassador {
                          id
                          status
                          fundraisingProfileID
                          fundraisingCampaignID
                          fundsRaised
                          initialTransactionID
                          initialTransactionAmount
                          ambassadorSpecificCtaUrl
                          createdAt
                          updatedAt
                          owner
                        }
                        owner
                      }
                    }
                  `,
                    variables: {
                        id: queryString.parse(window.location.search).contact
                    },
                    authMode: 'AWS_IAM'

                })

                console.log(data)
                if (data && data.getFundraisingCampaignAmbassadorContact) {
                    setFundraisingCampaignAmbassadorContact(data.getFundraisingCampaignAmbassadorContact)
                }
            }

            if (queryString.parse(window.location.search).view) {
                if (queryString.parse(window.location.search).view == 'overview') setPageStyle('overview')
                else if (queryString.parse(window.location.search).view == 'ambassador') setPageStyle('ambassador')
                else if (queryString.parse(window.location.search).view == 'initial-donation') setPageStyle('initial-donation')
                else setPageStyle('overview')
            }

            const queryStringParameters = queryString.parse(window.location.search)

            if (queryStringParameters && queryStringParameters.status && queryStringParameters.status == 'donation-success') {
                alert('Thanks for your donation.')
            } else if (queryStringParameters && queryStringParameters.status && queryStringParameters.status == 'donation-cancelled') {
                alert('Donation cancelled.')
            }
        })()
    }, [id])

    if (fundraisingCampaign) {
        return (
            <div style={{
                backgroundColor: 'white',
                minHeight: '100vh'
            }}>
                {
                    fundraisingCampaign &&
                    <meta property="og:title" content={fundraisingCampaign.campaignName ? fundraisingCampaign.campaignName : 'Fundraising Campaign'}></meta>
                }
                {
                    fundraisingCampaign && fundraisingCampaign.organizationID &&
                    <meta property="og:image" content={fundraisingCampaign.organizationID ? `https://public-flourish-assets.s3.us-east-2.amazonaws.com/organizations/${fundraisingCampaign.organizationID}/header.jpg` : 'https://public-flourish-assets.s3.us-east-2.amazonaws.com/organizations/3450fd5a-d9fd-4754-86c5-938c5bfc1696/header.jpg'}></meta>
                }

                {/* <div className="sticky-top p-5 pt-3 d-flex d-lg-none w-100" style={{ height: 0 }}>
                    <div className="p-5 w-100 bg-white border rounded d-flex flex-row justify-content-center align-items-center shadow" style={{ height: 0 }}>
                        <a href="#donate" className="w-100" style={{ textDecoration: 'none' }}>
                            <Button variant="contained" fullWidth onClick={() => { }}>Donate</Button>
                        </a>
                    </div>
                </div> */}
                <div style={{ visibility: 'hidden', height: 0 }}>
                    <FontPicker
                        pickerId='header'
                        apiKey="AIzaSyCg21oXmAoyibzWODyqlA8AZwBDt7jJNic"
                        activeFontFamily={headerSelectedFont ? headerSelectedFont.family : 'Open Sans'}
                        families={[
                            'Roboto', 'Open Sans', 'Montserrat', 'Poppins', 'Lato', 'Noto Sans', 'Fira Sans'
                        ]}
                    />
                    <FontPicker
                        pickerId='body'
                        apiKey="AIzaSyCg21oXmAoyibzWODyqlA8AZwBDt7jJNic"
                        activeFontFamily={bodySelectedFont ? bodySelectedFont.family : 'Open Sans'}
                        families={[
                            'Roboto', 'Open Sans', 'Montserrat', 'Poppins', 'Lato', 'Noto Sans', 'Fira Sans'
                        ]}
                    />
                </div>
                <div className="container-fluid g-0">
                    <div className="row g-0">
                        <div className="col-12 d-flex flex-row justify-content-between align-items-center p-4">
                            <div className="d-flex flex-row justify-content-center align-items-center">
                                <img
                                    src={fundraisingOrganizationLogo ? fundraisingOrganizationLogo : logo}
                                    style={{
                                        objectFit: 'contain',
                                        width: 200,
                                        height: 50,
                                        opacity: 1,
                                    }}
                                />
                                {/* <Typography variant="h4">{fundraisingCampaign.organization?.name}</Typography> */}
                            </div>
                            <div className="d-flex flex-column justify-content-end align-items-end">
                                <Typography variant="body1" className="apply-font-body">Campaign ends {fundraisingCampaign.campaignEndDate ? formatInTimeZone(new Date(fundraisingCampaign.campaignEndDate), "UTC", 'EEEE, LLLL do') : ''}</Typography>
                                <Typography variant="caption">{fundraisingCampaign.campaignEndDate ? differenceInDays(new Date(fundraisingCampaign.campaignEndDate), new Date()) >= 0 ? `(${differenceInDays(new Date(fundraisingCampaign.campaignEndDate), new Date())} days away)` : `(${Math.abs(differenceInDays(new Date(fundraisingCampaign.campaignEndDate), new Date()))} days ago)` : 'ERROR'}</Typography>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container-fluid p-0">
                    <div className="row g-0">
                        <div className="col-12 d-flex flex-column justify-content-center align-items-center mb-5 bg-light">
                            <img
                                src={fundraisingOrganizationHeaderImage ? fundraisingOrganizationHeaderImage : logo}
                                style={{
                                    objectFit: 'cover',
                                    maxWidth: '100%',
                                    width: '100%',
                                    height: 400,
                                    opacity: 0.25,
                                }}
                            />
                            <div className="d-flex flex-column justify-content-center align-items-center" style={{ position: 'absolute' }}>
                                <Typography variant="h1" className="apply-font-headers">{fundraisingCampaign.campaignName}</Typography>
                                <Typography variant="body1">Become a donor</Typography>
                                <a href="#donate" className="sticky-top" style={{ textDecoration: 'none' }}>
                                    <Button variant="contained" className="mt-3 px-4 sticky-top">Donate</Button>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container g-0">
                    <div className="row g-0">
                        <div className="col-12 col-lg-8 p-4 row" style={{ zIndex: 5, minHeight: '100vh' }}>
                            <div className="col-12 col-lg-3 d-flex flex-row justify-content-center align-items-center">
                                <ProfileAvatar authAccountID={fundraisingCampaignAmbassador?.fundraisingProfile?.authAccountID} size={150} />
                            </div>
                            <div className="col-12 col-lg-9">
                                <Typography variant="h1">{fundraisingCampaignAmbassador?.fundraisingProfile?.authAccount?.firstName} {fundraisingCampaignAmbassador?.fundraisingProfile?.authAccount?.lastName}</Typography>
                                {
                                    fundraisingCampaignInitialDonors &&
                                    fundraisingCampaignInitialDonors.map((donor: any) => {
                                        return (
                                            <Typography variant="h5" className="apply-font-body mb-3" style={{ fontWeight: 'bold' }}>{donor.anonymous ? 'Anonymous' : donor.donorName} donated ${Number(Number(donor.amount_total) / 100).toFixed(2)} to start the campaign. Multiply the impact by making a donation below.</Typography>
                                        )
                                    })
                                }
                                {
                                    fundraisingCampaignAnalytics && fundraisingCampaign.perAmbassadorGoal && fundraisingCampaignAmbassador &&
                                        fundraisingCampaign.type == FundraisingCampaignType.TenX ?
                                        <div className="d-flex flex-row justify-content-between align-items-center">
                                            <LinearProgress color='success' variant="determinate" value={Number(Number(Number(fundraisingCampaignAmbassador.fundsRaised) / 100) / Number(fundraisingCampaign.perAmbassadorGoal) * 100)} style={{ width: '90%' }} />
                                            <Typography mx="2" variant="body1" className="apply-font-header">{Number(Number(Number(fundraisingCampaignAnalytics.fundsRaised) / 100) / Number(fundraisingCampaign.perAmbassadorGoal) * 100)}%</Typography>
                                        </div>
                                        : fundraisingCampaign.type == FundraisingCampaignType.GivingCircle ?
                                            <div className="d-flex flex-row justify-content-between align-items-center">
                                                <LinearProgress color='success' variant="determinate" value={Number(Number(Number(fundraisingCampaignAnalytics.fundsRaised)) / Number(fundraisingCampaign.perAmbassadorGoal))} style={{ width: '90%' }} />
                                                <Typography mx="2" variant="body1" className="apply-font-header">{Number(Number(Number(fundraisingCampaignAnalytics.fundsRaised)) / Number(fundraisingCampaign.perAmbassadorGoal))}%</Typography>
                                            </div>
                                            :
                                            <div></div>
                                }
                                <Typography variant="caption">{fundraisingCampaignAmbassador?.fundsRaised} out of {fundraisingCampaign.type == FundraisingCampaignType.AmbassadorRecruiting ? `${fundraisingCampaign.perAmbassadorGoal}` : `${fundraisingCampaign.perAmbassadorGoal}`}</Typography>
                            </div>
                            <div className="col-12 mt-3 d-flex flex-row justify-content-start">
                                {
                                    fundraisingCampaign.publicVideoProvider == 'youtube' ?
                                        <iframe
                                            src={`https://www.youtube.com/embed/${fundraisingCampaign.publicVideoID ? fundraisingCampaign.publicVideoID : ''}`}
                                            frameBorder="0"
                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                            allowFullScreen
                                            title="Embedded youtube"
                                            style={{ width: '100%', maxHeight: '400px', height: '400px' }}
                                        />
                                        :
                                        fundraisingCampaign.publicVideoProvider == 'vimeo' ?
                                            <iframe
                                                src={`https://player.vimeo.com/video/${fundraisingCampaign.publicVideoID ? fundraisingCampaign.publicVideoID : ''}`}
                                                frameBorder="0"
                                                allow="autoplay; fullscreen; picture-in-picture"
                                                allowFullScreen
                                                title="Embedded vimeo"
                                                style={{ width: '100%', maxHeight: '400px', height: '400px' }}
                                            />
                                            :
                                            <div></div>
                                }
                            </div>
                            <div className="col-12 mt-3">
                                {fundraisingCampaign.publicCampaignAbout ? htmlParser(fundraisingCampaign.publicCampaignAbout) : ''}
                            </div>
                        </div>
                        <div className="col-12 col-lg-4 h-auto d-flex flex-column justify-content-start align-items-start p-1 pt-0 m-0 sticky-lg-top" style={{ maxHeight: '100vh', zIndex: 0, top: '100px !important' }}>
                            <div className="py-5">
                                <a id="donate" />
                                {
                                    (pageStyle == 'overview' || pageStyle == 'ambassador') && ((fundraisingCampaignAmbassadorContact && fundraisingCampaignAmbassadorContact.transactionID) == null || donateAgain) ?
                                        <div className="col-12 sticky-top d-flex flex-column justify-content-center align-items-center h-auto bg-white p-3 p-lg-5 rounded shadow">
                                            {/* <div className="d-flex flex-row justify-content-center d-lg-none">
                                            <img
                                                src={fundraisingOrganizationLogo ? fundraisingOrganizationLogo : logo}
                                                style={{
                                                    objectFit: 'contain',
                                                    width: '50%',
                                                    height: 100,
                                                    opacity: 1,
                                                    alignSelf: 'center'
                                                }}
                                            />
                                        </div> */}
                                            {/* <Typography my="2" variant="body1">{fundraisingCampaign.organization ? fundraisingCampaign.organization.name : ''}</Typography> */}
                                            <div className="row g-0 w-100">
                                                <div className="col-12 d-flex flex-row justify-content-start align-items-start">
                                                    <Typography variant="h3">Donate</Typography>
                                                </div>
                                                <div className="col-12 d-flex flex-row justify-content-start align-items-start mt-3">
                                                    {
                                                        fundraisingCampaignInitialDonors &&
                                                        fundraisingCampaignInitialDonors.map((donor: any) => {
                                                            return (
                                                                <Typography variant="h5" className="apply-font-body mb-3" style={{ fontWeight: 'bold' }}>{donor.anonymous ? 'Anonymous' : donor.donorName} donated ${Number(Number(donor.amount_total) / 100).toFixed(2)} to start the campaign. Multiply the impact by making a donation below.</Typography>
                                                            )
                                                        })
                                                    }
                                                </div>
                                                {
                                                    fundraisingCampaign.type == FundraisingCampaignType.TenX ?
                                                        <div className="col-12 d-flex flex-row justify-content-start align-items-center">
                                                            <TextField label="Donation amount" className="m-0 apply-font-body" type="number" value={donationAmount} onChange={(e) => { setDonationAmount(e.target.value) }} fullWidth InputProps={{ startAdornment: <InputAdornment position='start'>$</InputAdornment> }} />
                                                        </div>
                                                        : fundraisingCampaign.type == FundraisingCampaignType.GivingCircle ?
                                                            <div className="col-12 d-flex flex-row justify-content-start align-items-center">
                                                                <ToggleButtonGroup exclusive className="w-100" value={givingCircleSelectedDonation} onChange={(e, value) => setGivingCircleSelectedDonation(value)} fullWidth>
                                                                    {
                                                                        fundraisingCampaign.givingCircleIncrements ?
                                                                            fundraisingCampaign.givingCircleIncrements.map(increment => {
                                                                                if (increment) {
                                                                                    return (
                                                                                        <ToggleButton value={`${(Number(fundraisingCampaign.givingCircleBaseAmount) * increment).toFixed(0)}`} onChange={(e, value) => setGivingCircleSelectedDonation(value)}>${(Number(fundraisingCampaign.givingCircleBaseAmount) * increment).toFixed(0)}</ToggleButton>
                                                                                    )
                                                                                }
                                                                            })
                                                                            :
                                                                            <div></div>
                                                                    }
                                                                    {
                                                                        fundraisingCampaign.givingCircleAllowCustomAmounts &&
                                                                        <ToggleButton value="custom"><TextField variant="standard" label="Custom" value={givingCircleCustomDonationAmount} onChange={(e) => { if (Number(e.target.value || e.target.value == '')) setGivingCircleCustomDonationAmount(e.target.value) }} fullWidth InputProps={{ startAdornment: <InputAdornment position="end"><Typography variant="caption" mr="10px">$</Typography></InputAdornment> }} /></ToggleButton>
                                                                    }
                                                                </ToggleButtonGroup>
                                                            </div>
                                                            :
                                                            <div className="col-12 col-lg-6 d-flex flex-row justify-content-start align-items-center">
                                                                <TextField label="Donation amount" className="m-0 apply-font-body" type="number" value={donationAmount} onChange={(e) => { setDonationAmount(e.target.value) }} fullWidth InputProps={{ startAdornment: <InputAdornment position='start'>$</InputAdornment> }} />
                                                            </div>
                                                }
                                            </div>
                                            {
                                                !anonymousDonation &&
                                                <div className="d-flex flex-row justify-content-start align-items-center my-2 w-100">
                                                    <TextField fullWidth className="apply-font-body" label="Donor name" value={donorName} onChange={(e) => { setDonorName(e.target.value) }} />
                                                </div>
                                            }
                                            <div className="col-12 d-flex flex-row justify-content-center align-items-center my-2 w-100">
                                                <FormControlLabel className="apply-font-body" onChange={(e, value) => { setAnonymousDonation(value) }} checked={anonymousDonation} control={<Checkbox />} label="Make donation anonymous" />
                                            </div>
                                            <Button fullWidth className="my-3 apply-font-body" style={{ backgroundColor: fundraisingCampaign.buttonBackgroundColor ? `#${JSON.parse(fundraisingCampaign.buttonBackgroundColor).hex}` : '#C30023', borderColor: colors.primary[600], color: fundraisingCampaign.buttonTextColor ? `#${JSON.parse(fundraisingCampaign.buttonTextColor).hex}` : 'white', fontKerning: 'none', alignSelf: 'center' }}
                                                onClick={async () => {
                                                    console.log(donationAmount)
                                                    if ((donationAmount && Number(donationAmount) >= 1) || givingCircleSelectedDonation) {
                                                        const response = await axios.post(`https://9yim6q5pnf.execute-api.us-east-2.amazonaws.com/production/stripe/create-checkout-session`, {
                                                            type: fundraisingCampaign.type == FundraisingCampaignType.GivingCircle ? 'subscription' : 'oneTime',
                                                            amount: fundraisingCampaign.type == FundraisingCampaignType.GivingCircle ? givingCircleSelectedDonation == 'custom' && givingCircleCustomDonationAmount ? Number(givingCircleCustomDonationAmount) * 100 : Number(givingCircleSelectedDonation) * 100 : donationAmount ? Number(donationAmount) * 100 : 1000,
                                                            successURL: `${window.location.href}`,
                                                            cancelURL: `${window.location.href}`,
                                                            transactionName: `${fundraisingCampaign.type == FundraisingCampaignType.GivingCircle ? '' : 'Donation to '}${fundraisingCampaign.organization ? fundraisingCampaign.organization.name : 'Organization'}${fundraisingCampaign.campaignName ? ` for ${fundraisingCampaign.campaignName}` : ''}`,
                                                            organizationStripeConnectedAccountID: fundraisingCampaign.organization && fundraisingCampaign.organization.stripeConnectedAccountID ? fundraisingCampaign.organization.stripeConnectedAccountID : '',
                                                            organizationSubscription: fundraisingCampaign.organization && fundraisingCampaign.organization.latentSubscription ? fundraisingCampaign.organization.latentSubscription : 4,
                                                            metadata: {
                                                                for: 'LatentTransaction',
                                                                fundraisingCampaignID: fundraisingCampaign.id,
                                                                fundraisingCampaignAmbassadorID: fundraisingCampaignAmbassadorContact ? fundraisingCampaignAmbassadorContact.fundraisingCampaignAmbassadorID : fundraisingCampaignAmbassador ? fundraisingCampaignAmbassador.id : null,
                                                                fundraisingCampaignAmbassadorContactID: fundraisingCampaignAmbassadorContact ? fundraisingCampaignAmbassadorContact.id : null,
                                                                fundraisingProfileID: fundraisingCampaignAmbassadorContact ? fundraisingCampaignAmbassadorContact.fundraisingProfileID : fundraisingCampaignAmbassador ? fundraisingCampaignAmbassador.fundraisingProfileID : null,
                                                                anonymousDonation: anonymousDonation,
                                                                donorName: donorName,
                                                                organizationID: fundraisingCampaign.organizationID ? fundraisingCampaign.organizationID : null,
                                                                initialAmbassadorTransaction: false
                                                            }
                                                        })
                                                        console.log(response)
                                                        if (response.data && response.data && response.data.session && response.data.session.url) {
                                                            window.location.href = response.data.session.url
                                                        }
                                                    } else {
                                                        alert('Donation amount must be a valid number greater than 1.')
                                                    }
                                                }}
                                            >
                                                DONATE
                                            </Button>
                                            <img
                                                src={poweredByStripe}
                                                style={{
                                                    objectFit: 'contain',
                                                    width: 150,
                                                    height: 30,
                                                    opacity: 1,
                                                    alignSelf: 'center'
                                                }}
                                            />
                                        </div>
                                        : (pageStyle == 'overview' || pageStyle == 'ambassador') && fundraisingCampaignAmbassadorContact && (fundraisingCampaignAmbassadorContact.transactionID != null && !donateAgain) ?
                                            <div className="col-12 sticky-top d-flex flex-column justify-content-start align-items-start h-auto bg-white p-5 rounded shadow">
                                                <div className="d-flex flex-row justify-content-center d-lg-none">
                                                    <img
                                                        src={fundraisingOrganizationLogo ? fundraisingOrganizationLogo : logo}
                                                        style={{
                                                            objectFit: 'contain',
                                                            width: '50%',
                                                            height: 100,
                                                            opacity: 1,
                                                            alignSelf: 'center'
                                                        }}
                                                    />
                                                </div>
                                                <Typography variant="h1" className="mt-3 apply-font-header">{fundraisingCampaign.campaignName ? fundraisingCampaign.campaignName : ''}</Typography>
                                                {/* <Typography my="2" variant="body1">{fundraisingCampaign.organization ? fundraisingCampaign.organization.name : ''}</Typography> */}
                                                <Typography variant="h4" className="my-3 apply-font-body">Campaign ends {fundraisingCampaign.campaignEndDate ? formatInTimeZone(new Date(fundraisingCampaign.campaignEndDate), "UTC", 'EEEE, LLLL do') : ''} {fundraisingCampaign.campaignEndDate ? differenceInDays(new Date(fundraisingCampaign.campaignEndDate), new Date()) >= 0 ? `(${differenceInDays(new Date(fundraisingCampaign.campaignEndDate), new Date())} days away)` : `(${Math.abs(differenceInDays(new Date(fundraisingCampaign.campaignEndDate), new Date()))} days ago)` : 'ERROR'}</Typography>
                                                <Typography variant="body1" className="my-3 apply-font-body">You've already donated to this campaign. Here's information regarding your donation:</Typography>
                                                <Typography variant="body1" className="apply-font-body">Contact ID: {fundraisingCampaignAmbassadorContact.id}</Typography>
                                                <Typography variant="body1" className="apply-font-body">Transaction Amount: ${Number(Number(fundraisingCampaignAmbassadorContact.donationAmount) / 100)}</Typography>
                                                {
                                                    fundraisingCampaign.type == FundraisingCampaignType.GivingCircle ?
                                                        <div className="d-flex flex-column justify-content-center align-items-center">
                                                            <Typography variant="body1" className="mt-3">Enter the email associated with your donation and then click the "Manage Subscription" button to manage your current subscription.</Typography>
                                                            <TextField className="mt-3" fullWidth variant="outlined" label="Email" value={manageSubscriptionEmail} onChange={(e) => setManageSubscrtiptionEmail(e.target.value)} />
                                                            <Button className="mt-3 apply-font-body" sx={{ backgroundColor: '#FEAD77', borderColor: colors.primary[600], color: 'white', fontKerning: 'none', width: '50%', alignSelf: 'center' }} onClick={async () => {
                                                                const response = await axios.post(`https://9yim6q5pnf.execute-api.us-east-2.amazonaws.com/production/stripe/create-customer-portal-session`, {
                                                                    id: fundraisingCampaignAmbassadorContact ? fundraisingCampaignAmbassadorContact.id : null,
                                                                    email: manageSubscriptionEmail,
                                                                    type: 'standard',
                                                                    returnURL: window.location.href
                                                                })
                                                                console.log(response)
                                                                if (response.data && response.data.url) {
                                                                    window.location.replace(response.data.url)
                                                                }
                                                            }}>Manage Subscription</Button>
                                                        </div>
                                                        :
                                                        <Button className="mt-3 apply-font-body" sx={{ backgroundColor: '#FEAD77', borderColor: colors.primary[600], color: 'white', fontKerning: 'none', width: '50%', alignSelf: 'center' }} onClick={() => setDonateAgain(true)}>Donate again</Button>
                                                }
                                            </div>
                                            : pageStyle == 'initial-donation' ?
                                                <div></div>
                                                :
                                                <div className="col-12 d-flex flex-column justify-content-center align-items-center h-auto bg-white p-3 p-lg-5 rounded shadow">
                                                    <CircularProgress color="primary" />
                                                </div>
                                }
                                {
                                    pageStyle == 'initial-donation' && ((fundraisingCampaignInitialDonors == null || (fundraisingCampaignInitialDonors != null && fundraisingCampaignInitialDonors.length == 0)) || donateAgain) ?
                                        <div className="col-12 sticky-top d-flex flex-column justify-content-center h-auto bg-white p-5 rounded shadow">
                                            <div className="d-flex flex-row justify-content-center d-lg-none">
                                                <img
                                                    src={fundraisingOrganizationLogo ? fundraisingOrganizationLogo : logo}
                                                    style={{
                                                        objectFit: 'contain',
                                                        width: '50%',
                                                        height: 100,
                                                        opacity: 1,
                                                        alignSelf: 'center'
                                                    }}
                                                />
                                            </div>
                                            <Typography variant="h4" alignSelf="center">Initial Donation</Typography>
                                            <Typography variant="h1" className="mt-3 apply-font-header">{fundraisingCampaign.campaignName ? fundraisingCampaign.campaignName : ''}</Typography>
                                            {/* <Typography my="2" variant="body1">{fundraisingCampaign.organization ? fundraisingCampaign.organization.name : ''}</Typography> */}
                                            <Typography variant="h4" className="my-3 apply-font-body">Campaign ends {fundraisingCampaign.campaignEndDate ? formatInTimeZone(new Date(fundraisingCampaign.campaignEndDate), "UTC", 'EEEE, LLLL do') : ''} {fundraisingCampaign.campaignEndDate ? differenceInDays(new Date(fundraisingCampaign.campaignEndDate), new Date()) >= 0 ? `(${differenceInDays(new Date(fundraisingCampaign.campaignEndDate), new Date())} days away)` : `(${Math.abs(differenceInDays(new Date(fundraisingCampaign.campaignEndDate), new Date()))} days ago)` : 'ERROR'}</Typography>
                                            <div className="row g-0 w-100">
                                                {
                                                    fundraisingCampaign.type == FundraisingCampaignType.TenX ?
                                                        <div className="col-12 d-flex flex-row justify-content-start align-items-center">
                                                            <TextField label="Donation amount" className="m-0 apply-font-body" type="number" value={donationAmount} onChange={(e) => { setDonationAmount(e.target.value) }} fullWidth InputProps={{ startAdornment: <InputAdornment position='start'>$</InputAdornment> }} />
                                                        </div>
                                                        : fundraisingCampaign.type == FundraisingCampaignType.GivingCircle ?
                                                            <div className="col-12 d-flex flex-row justify-content-start align-items-center">
                                                                <ToggleButtonGroup exclusive className="w-100" value={givingCircleSelectedDonation} onChange={(e, value) => setGivingCircleSelectedDonation(value)} fullWidth>
                                                                    {
                                                                        fundraisingCampaign.givingCircleIncrements ?
                                                                            fundraisingCampaign.givingCircleIncrements.map(increment => {
                                                                                if (increment) {
                                                                                    return (
                                                                                        <ToggleButton value={`${(Number(fundraisingCampaign.givingCircleBaseAmount) * increment).toFixed(0)}`} onChange={(e, value) => setGivingCircleSelectedDonation(value)}>${(Number(fundraisingCampaign.givingCircleBaseAmount) * increment).toFixed(0)}</ToggleButton>
                                                                                    )
                                                                                }
                                                                            })
                                                                            :
                                                                            <div></div>
                                                                    }
                                                                    {
                                                                        fundraisingCampaign.givingCircleAllowCustomAmounts &&
                                                                        <ToggleButton value="custom"><TextField variant="standard" label="Custom" value={givingCircleCustomDonationAmount} onChange={(e) => { if (Number(e.target.value || e.target.value == '')) setGivingCircleCustomDonationAmount(e.target.value) }} fullWidth InputProps={{ startAdornment: <InputAdornment position="end"><Typography variant="caption" mr="10px">$</Typography></InputAdornment> }} /></ToggleButton>
                                                                    }
                                                                </ToggleButtonGroup>
                                                            </div>
                                                            :
                                                            <div className="col-12 d-flex flex-row justify-content-start align-items-center">
                                                                <TextField label="Donation amount" className="m-0 apply-font-body" type="number" value={donationAmount} onChange={(e) => { setDonationAmount(e.target.value) }} fullWidth InputProps={{ startAdornment: <InputAdornment position='start'>$</InputAdornment> }} />
                                                            </div>
                                                }
                                                <div className="col-12 d-flex flex-row justify-content-center align-items-center align-self-center my-2">
                                                    <FormControlLabel className="apply-font-body" onChange={(e, value) => { setAnonymousDonation(value) }} checked={anonymousDonation} control={<Checkbox />} label="Make donation anonymous" />
                                                </div>
                                            </div>
                                            {
                                                !anonymousDonation &&
                                                <div className="d-flex flex-row justify-content-start align-items-center my-2 w-100">
                                                    <TextField className="apply-font-body" fullWidth label="Donor name" value={donorName} onChange={(e) => { setDonorName(e.target.value) }} />
                                                </div>
                                            }
                                            <Button className="my-3 apply-font-body" style={{ backgroundColor: '#FEAD77', borderColor: colors.primary[600], color: 'white', fontKerning: 'none', width: '50%', alignSelf: 'center' }}
                                                onClick={async () => {
                                                    console.log(donationAmount)
                                                    if ((donationAmount && Number(donationAmount) >= 1) || givingCircleSelectedDonation) {
                                                        const response = await axios.post(`https://9yim6q5pnf.execute-api.us-east-2.amazonaws.com/production/stripe/create-checkout-session`, {
                                                            type: fundraisingCampaign.type == FundraisingCampaignType.GivingCircle ? 'subscription' : 'oneTime',
                                                            amount: fundraisingCampaign.type == FundraisingCampaignType.GivingCircle ? givingCircleSelectedDonation == 'custom' && givingCircleCustomDonationAmount ? Number(givingCircleCustomDonationAmount) * 100 : Number(givingCircleSelectedDonation) * 100 : donationAmount ? Number(donationAmount) * 100 : 1000,
                                                            successURL: `${window.location.href}`,
                                                            cancelURL: `${window.location.href}`,
                                                            transactionName: `${fundraisingCampaign.type == FundraisingCampaignType.GivingCircle ? '' : 'Donation to '}${fundraisingCampaign.organization ? fundraisingCampaign.organization.name : 'Organization'}${fundraisingCampaign.campaignName ? ` for ${fundraisingCampaign.campaignName}` : ''}`,
                                                            organizationStripeConnectedAccountID: fundraisingCampaign.organization && fundraisingCampaign.organization.stripeConnectedAccountID ? fundraisingCampaign.organization.stripeConnectedAccountID : '',
                                                            organizationSubscription: fundraisingCampaign.organization && fundraisingCampaign.organization.latentSubscription ? fundraisingCampaign.organization.latentSubscription : 4,
                                                            metadata: {
                                                                for: 'LatentTransaction',
                                                                fundraisingCampaignID: fundraisingCampaign.id,
                                                                fundraisingCampaignAmbassadorID: fundraisingCampaignAmbassadorContact ? fundraisingCampaignAmbassadorContact.fundraisingCampaignAmbassadorID : fundraisingCampaignAmbassador ? fundraisingCampaignAmbassador.id : null,
                                                                fundraisingCampaignAmbassadorContactID: fundraisingCampaignAmbassadorContact ? fundraisingCampaignAmbassadorContact.id : null,
                                                                fundraisingProfileID: fundraisingCampaignAmbassadorContact ? fundraisingCampaignAmbassadorContact.fundraisingProfileID : fundraisingCampaignAmbassador ? fundraisingCampaignAmbassador.fundraisingProfileID : null,
                                                                anonymousDonation: anonymousDonation,
                                                                donorName: donorName,
                                                                organizationID: fundraisingCampaign.organizationID ? fundraisingCampaign.organizationID : null,
                                                                initialAmbassadorTransaction: true
                                                            }
                                                        })
                                                        console.log(response)
                                                        if (response.data && response.data && response.data.session && response.data.session.url) {
                                                            window.location.href = response.data.session.url
                                                        }
                                                    } else {
                                                        alert('Donation amount must be a valid number greater than 1.')
                                                    }
                                                }}
                                            >
                                                DONATE
                                            </Button>
                                            <img
                                                src={poweredByStripe}
                                                style={{
                                                    objectFit: 'contain',
                                                    width: 150,
                                                    height: 30,
                                                    opacity: 1,
                                                    alignSelf: 'center'
                                                }}
                                            />
                                        </div>
                                        : pageStyle == 'initial-donation' && (fundraisingCampaignInitialDonors != null && !donateAgain) ?
                                            <div className="col-12 sticky-top d-flex flex-column justify-content-start align-items-start h-auto bg-white p-5 rounded shadow">
                                                <div className="d-flex flex-row justify-content-center d-lg-none">
                                                    <img
                                                        src={fundraisingOrganizationLogo ? fundraisingOrganizationLogo : logo}
                                                        style={{
                                                            objectFit: 'contain',
                                                            width: '50%',
                                                            height: 100,
                                                            opacity: 1,
                                                            alignSelf: 'center'
                                                        }}
                                                    />
                                                </div>
                                                <Typography variant="h1" className="mt-3 apply-font-header">{fundraisingCampaign.campaignName ? fundraisingCampaign.campaignName : ''}</Typography>
                                                {/* <Typography my="2" variant="body1">{fundraisingCampaign.organization ? fundraisingCampaign.organization.name : ''}</Typography> */}
                                                <Typography variant="h4" className="my-3 apply-font-body">Campaign ends {fundraisingCampaign.campaignEndDate ? formatInTimeZone(new Date(fundraisingCampaign.campaignEndDate), "UTC", 'EEEE, LLLL do') : ''} {fundraisingCampaign.campaignEndDate ? differenceInDays(new Date(fundraisingCampaign.campaignEndDate), new Date()) >= 0 ? `(${differenceInDays(new Date(fundraisingCampaign.campaignEndDate), new Date())} days away)` : `(${Math.abs(differenceInDays(new Date(fundraisingCampaign.campaignEndDate), new Date()))} days ago)` : 'ERROR'}</Typography>
                                                <Typography variant="body1">You've already made your initial donation</Typography>
                                                {
                                                    fundraisingCampaign.type == FundraisingCampaignType.GivingCircle ?
                                                        <div className="d-flex flex-column justify-content-center align-items-center">
                                                            <Typography variant="body1" className="mt-3">Enter the email associated with your donation and then click the "Manage Subscription" button to manage your current subscription.</Typography>
                                                            <TextField className="mt-3" fullWidth variant="outlined" label="Email" value={manageSubscriptionEmail} onChange={(e) => setManageSubscrtiptionEmail(e.target.value)} />
                                                            <Button className="mt-3 apply-font-body" sx={{ backgroundColor: '#FEAD77', borderColor: colors.primary[600], color: 'white', fontKerning: 'none', width: '50%', alignSelf: 'center' }} onClick={async () => {
                                                                const response = await axios.post(`https://9yim6q5pnf.execute-api.us-east-2.amazonaws.com/production/stripe/create-customer-portal-session`, {
                                                                    id: fundraisingCampaignAmbassadorContact ? fundraisingCampaignAmbassadorContact.fundraisingCampaignAmbassadorID : fundraisingCampaignAmbassador ? fundraisingCampaignAmbassador.id : null,
                                                                    email: manageSubscriptionEmail,
                                                                    type: 'ambassador',
                                                                    returnURL: window.location.href
                                                                })
                                                                console.log(response)
                                                                if (response.data && response.data.url) {
                                                                    window.location.replace(response.data.url)
                                                                }
                                                            }}>Manage Subscription</Button>
                                                        </div>
                                                        :
                                                        <Button className="mt-3 apply-font-body" sx={{ backgroundColor: '#FEAD77', borderColor: colors.primary[600], color: 'white', fontKerning: 'none', width: '50%', alignSelf: 'center' }} onClick={() => setDonateAgain(true)}>Donate again</Button>
                                                }
                                            </div>
                                            : pageStyle == 'overview' || pageStyle == 'ambassador' ?
                                                <div></div>
                                                :
                                                <div className="col-12 d-flex flex-column justify-content-center align-items-center h-auto bg-white p-3 p-lg-5 rounded shadow">
                                                    <CircularProgress color="primary" />
                                                </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        )
    } else {
        return (
            <div style={{ width: '100vw', height: '100vh' }}>
                <div className="w-100 h-100 d-flex flex-column justify-content-center align-items-center">
                    <CircularProgress />
                </div>
            </div>
        )
    }
}

async function asyncForEach(array: any[], callback: any) {
    for (let index = 0; index < array.length; index++) {
        await callback(array[index], index, array);
    }
}